module.exports = __webpack_public_path__ + "fonts/Lato-ThinItalic.2e89a614.eot";